/* Bulivia — Verhalten der eigenen Buy-Box-Bloecke.
   Laeuft beim Laden und erneut, wenn der Theme-Editor eine Section neu zeichnet. */
(function () {
  'use strict';

  function initToggles(root) {
    root.querySelectorAll('[data-bv-urgency-toggle], [data-bv-set-toggle]').forEach(function (btn) {
      if (btn.dataset.bvBound) return;
      btn.dataset.bvBound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  function deadlineFor(el) {
    var mode = el.dataset.mode;
    if (mode === 'daily') {
      // Zaehlt bis zur naechsten Wiederkehr dieser Uhrzeit.
      // Beispiel "03:00": laeuft von 3 Uhr bis 3 Uhr volle 24 Stunden
      // und startet danach von selbst wieder bei 24 Stunden.
      var parts = (el.dataset.dailyTime || '03:00').split(':');
      var ziel = new Date();
      ziel.setHours(parseInt(parts[0], 10) || 0, parseInt(parts[1], 10) || 0, 0, 0);
      if (ziel.getTime() <= Date.now()) ziel.setDate(ziel.getDate() + 1);
      return ziel.getTime();
    }
    var raw = (el.dataset.deadline || '').trim();
    if (!raw) return 0;
    var t = Date.parse(raw.replace(' ', 'T'));
    if (isNaN(t)) t = Date.parse(raw);
    return isNaN(t) ? 0 : t;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    root.querySelectorAll('[data-bv-countdown]').forEach(function (el) {
      if (el.dataset.bvTimer) clearInterval(parseInt(el.dataset.bvTimer, 10));
      var end = deadlineFor(el);
      var nums = {};
      el.querySelectorAll('[data-unit]').forEach(function (n) { nums[n.dataset.unit] = n; });

      function tick() {
        if (!end) return;
        var left = end - Date.now();
        if (left <= 0) {
          if (el.dataset.hideWhenOver === 'true') { el.style.display = 'none'; return; }
          left = 0;
        }
        var s = Math.floor(left / 1000);
        if (nums.days) nums.days.textContent = pad(Math.floor(s / 86400));
        if (nums.hours) nums.hours.textContent = pad(Math.floor(s / 3600) % 24);
        if (nums.minutes) nums.minutes.textContent = pad(Math.floor(s / 60) % 60);
        if (nums.seconds) nums.seconds.textContent = pad(s % 60);
      }
      tick();
      el.dataset.bvTimer = String(setInterval(tick, 1000));
    });
  }

  // Ausgewaehlte Farbe hinter das Label schreiben - wie bei Invisla
  // ("Farbe  Artic-Weiss"). Dawn zeigt bei Pillen nur "Farbe".
  function initVariantLabel(scope) {
    scope.querySelectorAll('.product__info-container variant-selects fieldset').forEach(function (fs) {
      var leg = fs.querySelector('legend.form__label');
      if (!leg) return;
      var checked = fs.querySelector('input:checked');
      if (!checked) return;
      var span = leg.querySelector('.bv-vp-value');
      if (!span) {
        span = document.createElement('span');
        span.className = 'bv-vp-value';
        leg.appendChild(span);
      }
      span.textContent = (checked.value || '').trim();
    });
  }

  function bvLastId(value) {
    return String(value || '').split('-').pop();
  }

  // --- Farbwahl: am Anfang ist nichts ausgewaehlt --------------
  // Shopify waehlt serverseitig immer eine Variante aus, deshalb
  // stand sonst schon beim Laden eine Farbe da und das Farbbild
  // war das erste Bild. Solange der Kunde nicht selbst geklickt
  // hat, blenden wir das Farbbild aus, nehmen die Markierung von
  // den Kreisen und sperren den Kaufen-Knopf. Nach dem Klick
  // steht die Variante in der Adresse - dann haelt sich das hier
  // komplett raus und Dawn macht wieder alles allein.
  function initColorGate() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    if (!container.querySelector('.bv-hero, .bv-set, .bv-savings')) return;
    var selects = container.querySelector('variant-selects');
    if (!selects || !selects.querySelector('input[type="radio"]')) return;
    if (/[?&]variant=/.test(window.location.search)) return;

    var parts = window.location.pathname.split('/products/');
    if (parts.length < 2) return;
    var handle = parts[1].split('/')[0].split('?')[0];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        var ids = {};
        data.variants.forEach(function (v) {
          if (v.featured_media) ids[String(v.featured_media.id)] = true;
        });
        if (!Object.keys(ids).length) return;

        document.querySelectorAll('.product__media-list .product__media-item').forEach(function (el) {
          if (ids[bvLastId(el.getAttribute('data-media-id'))]) el.style.display = 'none';
        });
        document.querySelectorAll('.thumbnail-list__item').forEach(function (el) {
          if (ids[bvLastId(el.getAttribute('data-target'))]) el.style.display = 'none';
        });

        selects.querySelectorAll('input[type="radio"]').forEach(function (i) { i.checked = false; });
        var value = selects.querySelector('.bv-vp-value');
        if (value) value.textContent = '';
        selects.setAttribute('data-bv-unset', '1');

        var btn = container.querySelector('.product-form__submit');
        if (!btn) return;
        var span = btn.querySelector('span');
        if (span) {
          btn.setAttribute('data-bv-label', span.textContent.trim());
          span.textContent = 'Bitte Farbe wählen';
        }
        btn.disabled = true;
        btn.classList.add('bv-cta--locked');
      })
      .catch(function () {});
  }

  // Nach dem ersten Klick auf einen Farbkreis wieder freigeben.
  // Die Galerie baut Dawn selbst neu auf, dort ist nichts zu tun.
  function releaseColorGate() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var selects = container.querySelector('variant-selects');
    if (selects) selects.removeAttribute('data-bv-unset');
    var btn = container.querySelector('.product-form__submit');
    if (!btn || !btn.classList.contains('bv-cta--locked')) return;
    var span = btn.querySelector('span');
    var label = btn.getAttribute('data-bv-label');
    if (span && label) span.textContent = label;
    btn.disabled = false;
    btn.classList.remove('bv-cta--locked');
  }

  // Punkte der Ergebnis-Section, nach Invislas Vorbild.
  // Ein Punkt je Karte: Klick scrollt die Karte heran, beim
  // Wischen wandert die Markierung von selbst mit. Kein
  // Fremdcode, nur natives Scrollen mit Einrasten.
  function initReviewSlider(scope) {
    scope.querySelectorAll('.bv-rev').forEach(function (rev) {
      var track = rev.querySelector('[data-bv-rev-track]');
      if (!track || track.dataset.bvBound === '1') return;
      track.dataset.bvBound = '1';

      var dots = rev.querySelectorAll('[data-bv-rev-dot]');
      if (!dots.length) return;

      function cards() { return rev.querySelectorAll('.bv-rev__card'); }

      function mark(index) {
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === index);
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-bv-rev-dot'), 10) || 0;
          var card = cards()[i];
          if (!card) return;
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          mark(i);
        });
      });

      // Beim Wischen die naechstgelegene Karte markieren.
      var timer = null;
      track.addEventListener('scroll', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          var list = cards();
          var mitte = track.scrollLeft + track.clientWidth / 2;
          var beste = 0;
          var abstand = Infinity;
          for (var i = 0; i < list.length; i++) {
            var c = list[i];
            var cm = c.offsetLeft - track.offsetLeft + c.offsetWidth / 2;
            var diff = Math.abs(cm - mitte);
            if (diff < abstand) { abstand = diff; beste = i; }
          }
          mark(beste);
        }, 90);
      }, { passive: true });
    });
  }

  // Kundenstimmen: wechselt von selbst weiter, wie bei Botanique
  // alle paar Sekunden. Haelt an, solange die Maus darauf liegt,
  // und hoert ganz auf, sobald jemand selbst wischt oder einen
  // Punkt antippt - sonst springt es unter den Fingern weg.
  function initVoices(scope) {
    scope.querySelectorAll('[data-bv-voices]').forEach(function (box) {
      var track = box.querySelector('[data-bv-voices-track]');
      if (!track || track.dataset.bvBound === '1') return;
      track.dataset.bvBound = '1';

      var items = box.querySelectorAll('.bv-voices__item');
      var dots = box.querySelectorAll('[data-bv-voices-dot]');
      if (items.length < 2) return;

      var aktiv = 0;
      var timer = null;
      var gestoppt = false;

      function mark(i) {
        aktiv = i;
        for (var n = 0; n < dots.length; n++) dots[n].classList.toggle('is-active', n === i);
      }
      function zeige(i, sanft) {
        var el = items[i];
        if (!el) return;
        track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: sanft ? 'smooth' : 'auto' });
        mark(i);
      }
      function weiter() { zeige((aktiv + 1) % items.length, true); }

      function start() {
        if (gestoppt || timer) return;
        // Botanique: 4s Standzeit PLUS 0,5s Uebergang, und die
        // Standzeit laeuft erst nach dem Uebergang wieder an.
        var takt = (parseFloat(box.dataset.interval) || 4) * 1000 + 500;
        timer = setInterval(weiter, takt);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function fuerImmerStoppen() { gestoppt = true; stop(); }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          fuerImmerStoppen();
          zeige(parseInt(dot.getAttribute('data-bv-voices-dot'), 10) || 0, true);
        });
      });
      track.addEventListener('pointerdown', fuerImmerStoppen);
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', start);

      // Beim Wischen den Punkt mitziehen.
      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var mitte = track.scrollLeft + track.clientWidth / 2;
          var beste = 0, abstand = Infinity;
          for (var i = 0; i < items.length; i++) {
            var c = items[i];
            var cm = c.offsetLeft - track.offsetLeft + c.offsetWidth / 2;
            var diff = Math.abs(cm - mitte);
            if (diff < abstand) { abstand = diff; beste = i; }
          }
          mark(beste);
        }, 90);
      }, { passive: true });

      if (box.dataset.autoplay === 'true') start();
    });
  }

  // Haeufige Fragen: es bleibt immer nur eine Frage offen.
  function initFaq(scope) {
    scope.querySelectorAll('[data-bv-faq]').forEach(function (faq) {
      if (faq.dataset.bvBound === '1') return;
      faq.dataset.bvBound = '1';
      var items = faq.querySelectorAll('[data-bv-faq-item]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (anderes) {
            if (anderes !== item) anderes.open = false;
          });
        });
      });
    });
  }


  /* --- Prozent-Ringe: Einblenden wie bei Boulina, dazu das
     Auffuellen der Ringe. Beides nur, wenn die Section es
     verlangt und der Nutzer Bewegung nicht abgeschaltet hat. --- */
  function initProzente(scope) {
    var wurzel = scope && scope.querySelectorAll ? scope : document;
    var boxen = wurzel.querySelectorAll('.bv-pz:not([data-bv-pz-bereit])');
    if (!boxen.length) return;

    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(boxen, function (box) {
      box.setAttribute('data-bv-pz-bereit', '1');
      box.classList.add('bv-pz--js');

      var ringe = box.querySelectorAll('[data-bv-pz-ring]');
      var fuellen = box.getAttribute('data-bv-pz-fuellen') === '1' && !ruhig;
      var dauer = parseInt(box.getAttribute('data-bv-pz-dauer'), 10) || 1200;
      // Die Ringe starten erst, wenn ihre Spalte eingeblendet ist —
      // sonst laeuft alles gleichzeitig und wirkt gehetzt.
      var verzug = parseInt(box.getAttribute('data-bv-pz-verzug'), 10) || 0;

      if (fuellen) {
        Array.prototype.forEach.call(ringe, function (r) {
          r.style.setProperty('--bv-pz-p', '0%');
          var p = r.querySelector('p');
          if (p) p.textContent = '0%';
        });
      }

      var gestartet = false;
      function zeigen() {
        if (gestartet) return;
        gestartet = true;
        box.classList.add('bv-pz--shown');
        if (!fuellen) return;

        var start = null;
        function schritt(t) {
          if (start === null) start = t;
          var f = Math.min(1, (t - start) / dauer);
          // weiches Auslaufen, damit es sich wie ein Ladering anfuehlt
          var e = 1 - Math.pow(1 - f, 3);
          Array.prototype.forEach.call(ringe, function (r) {
            var ziel = parseFloat(r.getAttribute('data-p')) || 0;
            var wert = ziel * e;
            r.style.setProperty('--bv-pz-p', wert.toFixed(2) + '%');
            var p = r.querySelector('p');
            if (p) p.textContent = Math.round(wert) + '%';
          });
          if (f < 1) requestAnimationFrame(schritt);
        }
        if (verzug > 0) {
          setTimeout(function () { requestAnimationFrame(schritt); }, verzug);
        } else {
          requestAnimationFrame(schritt);
        }
      }

      if (!('IntersectionObserver' in window)) { zeigen(); return; }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) { zeigen(); beobachter.disconnect(); }
        });
      }, { threshold: 0.2 });
      beobachter.observe(box);
    });
  }


  /* --- Statistik: Zaehler 1:1 wie bei Invisla. Alle Zahlen
     laufen gleichzeitig um 1 pro Takt hoch, der Takt ist die
     Dauer geteilt durch den groessten Zielwert — dadurch kommen
     alle gemeinsam an. Die Prozentspalte bekommt vorher eine
     feste Mindestbreite, damit der Text beim Zaehlen nicht
     wackelt. --- */
  function initStatistik(scope) {
    var wurzel = scope && scope.querySelectorAll ? scope : document;
    var boxen = wurzel.querySelectorAll('[data-bv-st]:not([data-bv-st-bereit])');
    if (!boxen.length) return;

    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(boxen, function (box) {
      box.setAttribute('data-bv-st-bereit', '1');

      var wraps = box.querySelectorAll('[data-bv-st-wrap]');
      var spans = box.querySelectorAll('[data-bv-st-zahl]');
      if (!spans.length) return;

      var zaehlen = box.getAttribute('data-bv-st-zaehlen') === '1' && !ruhig;
      var dauer = parseInt(box.getAttribute('data-bv-st-dauer'), 10) || 2000;
      var puffer = 10;

      // Nur reine Ganzzahlen zaehlen hoch. Werte wie "4,9" oder
      // "1.200" bleiben stehen, wie sie eingetragen wurden.
      var ziele = [];
      Array.prototype.forEach.call(spans, function (el) {
        var roh = (el.getAttribute('data-target') || '').trim();
        if (!/^\d+$/.test(roh)) return;
        ziele.push({ el: el, ziel: parseInt(roh, 10), jetzt: 0 });
      });
      if (!ziele.length) zaehlen = false;

      function breitenSetzen() {
        Array.prototype.forEach.call(wraps, function (w) { w.style.minWidth = ''; });
        var alt = Array.prototype.map.call(spans, function (s) { return s.textContent; });
        ziele.forEach(function (t) { t.el.textContent = t.ziel; });
        var max = 0;
        Array.prototype.forEach.call(wraps, function (w) {
          max = Math.max(max, Math.ceil(w.getBoundingClientRect().width));
        });
        if (max > 0) {
          Array.prototype.forEach.call(wraps, function (w) { w.style.minWidth = (max + puffer) + 'px'; });
        }
        alt.forEach(function (v, i) { spans[i].textContent = v; });
      }

      if (zaehlen) {
        ziele.forEach(function (t) { t.el.textContent = '0'; });
      }
      breitenSetzen();

      var neuMessen = function () { breitenSetzen(); };
      window.addEventListener('resize', neuMessen);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          if (document.body.contains(box)) breitenSetzen();
        });
      }

      if (!zaehlen) return;

      function starten() {
        ziele.forEach(function (t) { t.jetzt = 0; t.el.textContent = '0'; });
        var groesster = Math.max.apply(null, ziele.map(function (t) { return t.ziel; }));
        var takt = groesster > 0 ? Math.floor(dauer / groesster) : dauer;
        if (takt < 1) takt = 1;
        var uhr = setInterval(function () {
          var fertig = true;
          ziele.forEach(function (t) {
            if (t.jetzt < t.ziel) { t.jetzt++; t.el.textContent = t.jetzt; fertig = false; }
          });
          if (fertig) clearInterval(uhr);
        }, takt);
      }

      if (!('IntersectionObserver' in window)) { starten(); return; }
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          beobachter.disconnect();
          starten();
        });
      });
      beobachter.observe(box);
    });
  }

  function init(root) {
    var scope = root || document;
    initToggles(scope);
    initCountdowns(scope);
    initVariantLabel(scope);
    initColorGate();
    initReviewSlider(scope);
    initVoices(scope);
    initFaq(scope);
    initProzente(scope);
    initStatistik(scope);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product__info-container variant-selects')) {
      releaseColorGate();
      setTimeout(function () { initVariantLabel(document); }, 0);
      setTimeout(function () { initVariantLabel(document); }, 600);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target); });
})();
